import React, { useState, useEffect, useRef } from 'react';
import { find, path, propEq, propOr } from 'ramda';
import { useTranslate } from '../../translate/I18n';
import SanitizedHTML from '../elements/SanitizedHTML';
import { isInBrowser } from '../../utils/reactOrNext';

const chapters = [
  'beelanceMissionStatement',
  'platformLicenseAgreement',
  'customerFreelanceMissionAgreement',
  'taskOrderTemplate'
];

const LegalCenter = () => {
  const [bodyOffset, setBodyOffset] = useState(isInBrowser() ? document.body.getBoundingClientRect() : { top: 0 });
  const [scrollY, setScrollY] = useState(bodyOffset.top);
  const [chaptersProps, setChaptersProps] = useState([]);

  const [currentChapter, setCurrentChapter] = useState(chapters[0]);
  const termsOfUseRef = useRef();

  const { t } = useTranslate(['legal', ...chapters]);

  const scrollHandler = () => {
    setBodyOffset(document.body.getBoundingClientRect());
    setScrollY(-bodyOffset.top);
    detectCurrentChapter();
  };

  const calculateChapterProps = () => {
    const chaptersRef = Array.from(path(['current', 'children'], termsOfUseRef));
    setChaptersProps(
      chaptersRef.map(({ id, offsetTop = 0, offsetHeight = 0 }) => ({
        offsetTop,
        offsetBottom: offsetTop + offsetHeight,
        id
      }))
    );
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  });

  useEffect(() => {
    calculateChapterProps();
  }, []);

  const handleNav = elementId => {
    const selectedElement = find(propEq('id', elementId), chaptersProps);
    const topPaddingScroll = 100;
    calculateChapterProps();
    handleScroll(propOr(0, 'offsetTop', selectedElement) - topPaddingScroll);
  };

  const handleScroll = top => {
    window.scrollTo({
      top: top,
      left: 0,
      behavior: 'auto'
    });
  };

  const detectCurrentChapter = () => {
    (chaptersProps || []).forEach(currentChapterProp => {
      if (scrollY > currentChapterProp.offsetTop - 200 && scrollY < currentChapterProp.offsetBottom - 200) {
        setCurrentChapter(currentChapterProp.id);
      }
    });
  };

  return (
    <div className="content-with-sidebar">
      <div className="sidebar-nav">
        <div className="sidebar-nav__content">
          <p className="sidebar-nav__link">{t('legal:platformTermOfUse')}</p>
          <nav>
            <ul className="sidebar-nav__sections">
              {chapters.map(chapter => (
                <li key={chapter} className="sidebar-nav__linkwrapper">
                  <span
                    className={`sidebar-nav__link ${currentChapter === chapter ? 'sidebar-nav__link--active' : ''}`}
                    id={chapter}
                    onClick={e => handleNav(e.target.id)}>
                    {t(`${chapter}:label`)}
                  </span>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <article ref={termsOfUseRef} className="col-sm pv ph-double article content">
        <h1>Beelance platform terms of use</h1>

        {chapters.map(chapter => (
          <article key={chapter} id={chapter} className="article__document mb-double">
            <h2>{t(`${chapter}:title`)}</h2>
            <SanitizedHTML content={t(`${chapter}:content`)} />
          </article>
        ))}
      </article>
      <div className="btn btn--toTop" onClick={() => handleScroll(0)} />
    </div>
  );
};

export default LegalCenter;
